
import MultiSceneCommand from './MultiSceneCommand';
import selectMode from './selectMode';

export default class MultiSceneCommandSelectMode extends MultiSceneCommand {

    constructor(options) {
        super(options);
        this._name = 'SELECT_MODE';
    }

    execute(multiSceneViewer, params) {
        selectMode(multiSceneViewer, params.modeId);
    }
}
